module.exports = __webpack_public_path__ + "img/Arrow.87fe328c.svg";